import { markTaskAsCompletedError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getMarkTaskAsCompletedError({ uuid }) {
      const req = getState().find(({ task }) => task.uuid === uuid);

      return req ? req.error : markTaskAsCompletedError;
    },
    isMarkTaskAsCompletedRequestFailure({ uuid }) {
      const req = getState().find(({ task }) => task.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isMarkTaskAsCompletedRequestPending({ uuid }) {
      const req = getState().find(({ task }) => task.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isMarkTaskAsCompletedRequestSuccess({ uuid }) {
      const req = getState().find(({ task }) => task.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
